import { css } from 'linaria';
import { useTranslation } from 'next-i18next';
import { breakpointMediumHandset } from '@pocket/web-ui';
import Link from 'next/link';
const recentSearchStyle = "r1yd3t3b";
export function RecentSearches({
  searchTerms = []
}) {
  const {
    t
  } = useTranslation();
  return searchTerms.length ? <div className={recentSearchStyle}>
      <h4 className="title">
        {t('search:recent-searches', 'Recent Searches')}
      </h4>

      {searchTerms.map(search => <div key={search}>
          <Link href={`/my-list/search?query=${encodeURIComponent(search)}`}>
            <a tabIndex={0}>{search}</a>
          </Link>
        </div>)}
    </div> : null;
}

require("../../../../../.linaria-cache/src/components/global-nav/tools/search/recent-searches.linaria.module.css");